import { useEffect, useState } from 'react';

/**
 * Subscribe to a CSS media query — returns false during SSR.
 */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const mq = window.matchMedia(query);
    const update = () => setMatches(mq.matches);
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, [query]);

  return matches;
}

/** Tailwind 2xl breakpoint — enough room for profile + guidance sidebar. */
export function useIs2xlUp() {
  return useMediaQuery('(min-width: 1536px)');
}
